import { render } from "./VerseRefsWidget.vue?vue&type=template&id=f21e6e98&scoped=true"
import script from "./VerseRefsWidget.vue?vue&type=script&lang=js"
export * from "./VerseRefsWidget.vue?vue&type=script&lang=js"

import "./VerseRefsWidget.vue?vue&type=style&index=0&id=f21e6e98&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f21e6e98"]])

export default __exports__